import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {Box, Flex, Image} from '@chakra-ui/react';
import React, {useRef} from 'react';
import type {Swiper as SwiperType} from 'swiper';
import {A11y, Keyboard, Navigation, Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import {useDesktop} from '../../../../../../hooks';
import {IProduct} from '../../../../../../types';
import {SliderArrow} from '../../../../../shared';
import DiscountLabel from '../../../DiscountLabel';
import {MetroFavoriteButton} from '../../../metro-favorite-button/MetroFavoriteButton';
import {ProductEditPhotoButton} from '../../../metro-product-edit-modal';

interface ImageSliderProps {
  images: string[];
  productId?: number;
  oldPrice?: number;
  price?: number;
  //edit photo
  product: IProduct;
  onSuccess: () => void;
  onCloseParent: () => void;
}

export const ImageSlider = ({
  images,
  productId,
  oldPrice,
  price,
  product,
  onSuccess,
  onCloseParent,
}: ImageSliderProps) => {
  const isDesktop = useDesktop();
  const swiperRef = useRef<SwiperType | null>(null);

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  return (
    <Box position="relative" w="100%" borderRadius="xl" overflow="hidden">
      {productId && (
        <Box position="absolute" top="8px" right={isDesktop ? '8px' : '20px'} zIndex={100}>
          <Flex alignItems="center" gap={2}>
            <ProductEditPhotoButton product={product} onSuccess={onSuccess} onCloseParent={onCloseParent} />
            <MetroFavoriteButton productId={productId} size={20} />
          </Flex>
        </Box>
      )}
      <DiscountLabel oldPrice={oldPrice} price={price} bottom={undefined} top="8px" />

      {isDesktop && images.length > 1 && (
        <>
          <Box position="absolute" left="5px" top="50%" transform="translateY(-50%)" zIndex={10}>
            <SliderArrow variant="left" left="5px" onClick={handlePrev} />
          </Box>
          <Box position="absolute" right="5px" top="50%" transform="translateY(-50%)" zIndex={10}>
            <SliderArrow variant="right" right="5px" onClick={handleNext} />
          </Box>
        </>
      )}

      {images.length ? (
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          modules={[Navigation, Pagination, Keyboard, A11y]}
          slidesPerView={1}
          loop={images.length > 1}
          speed={500}
          pagination={{clickable: true}}
          keyboard={{enabled: true}}
          a11y={{
            prevSlideMessage: 'Previous image',
            nextSlideMessage: 'Next image',
          }}
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <Box w="100%" h="100%">
                <Image
                  src={src}
                  alt={`image-${index}`}
                  objectFit="contain"
                  w="100%"
                  h="100%"
                  fallback={
                    <Image
                      src="/food_pattern.webp"
                      borderRadius="16px"
                      alt="fallback"
                      objectFit="cover"
                      w="100%"
                      h="50vh"
                    />
                  }
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Image src="/food_pattern.webp" borderRadius="16px" alt="fallback" objectFit="cover" w="100%" h="50vh" />
      )}
    </Box>
  );
};
